import {FC, useEffect, useState} from 'react'
import {ILayout, useLayout} from '../../core'
import {MenuInner} from './header-menus'
import { useLocation } from 'react-router-dom'
import { useClaimAttention } from '../../../../hooks/useClaimAttention';

// Modify the AttentionState interface to include more details
interface AttentionState {
  isEnabled: boolean;
  claimNumber: string;
  status?: string;
}

// Update global state
let globalAttentionState: AttentionState = {
  isEnabled: false,
  claimNumber: '',
  status: ''
};

// Update setter function to include status
export const setGlobalAttention = (isEnabled: boolean, claimNumber: string, status?: string) => {
  globalAttentionState = {
    isEnabled,
    claimNumber,
    status
  };
  console.log('Setting global attention state:', globalAttentionState);
  window.dispatchEvent(new Event('attentionStateChanged'));
};

const Header: FC = () => {
  const {config} = useLayout()
  const [showAttention, setShowAttention] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleAttentionChange = () => {
      const isInpatientPage = location.pathname.includes('/inpatient');
      const shouldShowAttention = isInpatientPage && 
                                globalAttentionState.isEnabled && 
                                globalAttentionState.status === "Pending on IGL";
      
      setShowAttention(shouldShowAttention);

      console.log('Attention state updated:', {
        isInpatientPage,
        isEnabled: globalAttentionState.isEnabled,
        status: globalAttentionState.status,
        claimNumber: globalAttentionState.claimNumber,
        showAttention: shouldShowAttention
      });
    };

    window.addEventListener('attentionStateChanged', handleAttentionChange);
    handleAttentionChange(); // Initial check
    
    return () => {
      window.removeEventListener('attentionStateChanged', handleAttentionChange);
    };
  }, [location.pathname]);

  return (
    <div className='d-flex align-items-center justify-content-between w-100'>
      <div
        className='
          menu
          menu-rounded
          menu-column
          menu-lg-row
          my-5
          my-lg-0
          align-items-stretch
          fw-semibold
          px-2 px-lg-0
        '
        id='kt_app_header_menu'
        data-kt-menu='true'
      >
        <MenuInner />
      </div>
      
      {showAttention && (
        <div 
          className='attention-message me-5 d-flex align-items-center'
          style={{
            color: 'red',
            fontWeight: 'bold',
            animation: 'blink 1s infinite',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '14px',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1,
          }}
        >
          Silakan klik tombol "Request IGL" untuk melanjutkan proses!
        </div>
      )}

      <style>
        {`
          @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.header?.default?.fixed?.desktop) {
    document.body.setAttribute('data-kt-app-header-fixed', 'true')

    document.body.setAttribute('data-kt-app-header-minimize', 'on')
  }

  if (config.app?.header?.default?.fixed?.mobile) {
    document.body.setAttribute('data-kt-app-header-fixed-mobile', 'true')
  }

  if (config.app?.header?.default?.stacked) {
    document.body.setAttribute('data-kt-app-header-stacked', 'true')
  }

  const appHeaderDefaultStickyEnabled = config.app?.header?.default?.sticky?.enabled
  let appHeaderDefaultStickyAttributes: {[attrName: string]: string} = {}
  if (appHeaderDefaultStickyEnabled) {
    appHeaderDefaultStickyAttributes = config.app?.header?.default?.sticky?.attributes as {
      [attrName: string]: string
    }
  }

  const appHeaderDefaultMinimizeEnabled = config.app?.header?.default?.minimize?.enabled
  let appHeaderDefaultMinimizeAttributes: {[attrName: string]: string} = {}
  if (appHeaderDefaultMinimizeEnabled) {
    appHeaderDefaultMinimizeAttributes = config.app?.header?.default?.minimize?.attributes as {
      [attrName: string]: string
    }
  }

  setTimeout(() => {
    const headerElement = document.getElementById('kt_app_header')
    // header
    if (headerElement) {
      const headerAttributes = headerElement
        .getAttributeNames()
        .filter((t) => t.indexOf('data-') > -1)
      headerAttributes.forEach((attr) => headerElement.removeAttribute(attr))

      if (appHeaderDefaultStickyEnabled) {
        for (const key in appHeaderDefaultStickyAttributes) {
          if (appHeaderDefaultStickyAttributes.hasOwnProperty(key)) {
            headerElement.setAttribute(key, appHeaderDefaultStickyAttributes[key])
          }
        }
      }

      if (appHeaderDefaultMinimizeEnabled) {
        for (const key in appHeaderDefaultMinimizeAttributes) {
          if (appHeaderDefaultMinimizeAttributes.hasOwnProperty(key)) {
            headerElement.setAttribute(key, appHeaderDefaultMinimizeAttributes[key])
          }
        }
      }
    }
  }, 0)
}

export {Header}
